import React from "react";
import ProvincesView from "../../../views/dashboard/provinces";

const Provinces = () => {
  return <ProvincesView />;
};

export default Provinces;
